import { useRequiredContext } from "@redotech/react-util/context";
import {
  createContext,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from "react";

interface FeedbackPopoverContextValue {
  isOpen: boolean;
  open: () => void;
  close: () => void;
  setOpen: (open: boolean) => void;
}

const FeedbackPopoverContext = createContext<
  FeedbackPopoverContextValue | undefined
>(undefined);

export function FeedbackPopoverProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  const value = useMemo(
    () => ({ isOpen, open, close, setOpen: setIsOpen }),
    [isOpen, open, close],
  );

  return (
    <FeedbackPopoverContext.Provider value={value}>
      {children}
    </FeedbackPopoverContext.Provider>
  );
}

export function useFeedbackPopover(): FeedbackPopoverContextValue {
  return useRequiredContext(FeedbackPopoverContext);
}
